module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9669.d83bf328.jpg";